export const accountsBalancesFields = [
  {
    currency: ["currency_id", "precision"],
  },
  "free_balance",
  "wallet_id",
];

export const userFields = ["user_id", "limit_group_id", "mfa_status"];

export const paymentsLimitsFields = ["deposit_min_amount", "withdrawal_min_amount", "currency_id"];

export const createWithdrawalFiatFields = ["payment_id"];

export const paymentsRoutesFields = ["verification_type"];
